export default __webpack_public_path__ + "static/4-901a2632e50db71196f437ce822de3ed.png";